/**
 * Each app results in a separate bundle
 */
module.exports = {
    WEBAPP: 'webapp',
    ESPNAPP: 'espnapp'
};



// WEBPACK FOOTER //
// ./config/appNames.js